<!-- <div class="header">
    <a class="back-button" (click)="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        <span>Back</span>
    </a>
</div>

<div class="white-screen">
    <h2>Congrats !</h2>

    <div *ngIf="isNewUser">
        <p class="subtitle">
            You've successfully set up your store!<br />
            To access your store management dashboard and start tracking,<br />
            please complete the registration form below.
        </p>

        <form class="form-container" [formGroup]="storeRequestForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <div class="input-block">
                    <label>First Name</label>
                    <input type="text" placeholder="Enter Your First Name" formControlName="firstName" />
                </div>
                <div class="input-block">
                    <label>Last Name</label>
                    <input type="text" placeholder="Enter Your Last Name" formControlName="lastName" />
                </div>
            </div>

            <div class="form-group">
                <div class="input-block">
                    <label>Store Name</label>
                    <input type="text" placeholder="Enter Store Name" formControlName="name" />
                </div>
                <div class="input-block">
                    <label>Market/ Audience</label>
                    <select formControlName="marketId">
                        <option value="">Select Market/ Audience</option>
                        <option *ngFor="let market of markets" [value]="market.id">{{ market.name }}</option>
                    </select>
                </div>
            </div>

            <div class="form-group">
                <div class="input-block">
                    <label>Phone number</label>
                    <input type="text" placeholder="Enter Phone Number" formControlName="phoneNumber" />
                </div>
                <div class="input-block">
                    <label>State/ Region</label>
                    <select formControlName="shipToState">
                        <option value="">Select State</option>
                        <option *ngFor="let state of states" [value]="state.code">{{ state.name }}</option>
                    </select>
                </div>
            </div>

            <div class="form-group full-width" *ngIf="isLaunchAction">
                <div class="input-block">
                    <label>Shipment Method</label>
                    <select formControlName="shippingPreference">
                        <option value="">Select Shipping Method</option>
                        <option *ngFor="let method of shippingMethods" [value]="method.id">{{ method.name }}</option>
                    </select>
                </div>
            </div>

            <div class="form-group checkbox">
                <label>
                    <input type="checkbox" formControlName="agreeToTerms"  (change)="termsChanged()" />
                    By clicking "Complete", I agree to the
                    <a href="/terms">terms of service</a>.
                </label>
            </div>

            <button type="submit" class="primary-btn" >Complete And View Store Dashboard</button>
        </form>
    </div>

    <p *ngIf="!isNewUser && isLaunchAction" class="success-text">
        You've successfully set up your store!<br />
        To access your store management dashboard, please go to<br />
        <a [routerLink]="['/enduser/useraccount/my-stores']" class="blue-link">My Account/My Stores</a>
    </p>

    <p *ngIf="!isNewUser && !isLaunchAction" class="success-text">
        You've successfully saved your store!<br />
        To access your draft store dashboard, please go to<br />
        <a [routerLink]="['/enduser/useraccount/my-stores']" class="blue-link">My Account/My Stores</a>
    </p>

    <div *ngIf="!isNewUser" class="button-group">
        <button (click)="goBack()" class="secondary-btn">Back To Home Page</button>
        <button [routerLink]="['/enduser/useraccount/my-stores']" class="primary-btn">My Stores</button>
    </div>
</div> -->


<div class="success-wrapper">
    <!-- Tick GIF Animation -->
    <img src="../../../../../../assets/images/ok.gif" alt="Success" class="tick-icon" />

    <!-- Optional Success Message -->
    <h2 class="success-title">You're All Set!</h2>
    <!-- <p class="success-subtitle">Your store has been successfully created.</p> -->

    <!-- Button to go to store -->
    <button class="success-btn" (click)="goToMyStores()">
       View Store Dashboard
    </button>
</div>
  